/**
 * @file_purpose  axios api call for handling apis for visitor manager
 * @author Swarnali Ghosh
 * @Date_Created 02-08-2023
 * @Date_Modified 11-08-2023
 */
import API from '../apis/API';
import ApiURL from '../apis/ApiURL';
var accessToken = localStorage.getItem("visitor_manager_auth_token");

const VisitorManagementService = {
    visitorManagerlogin: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.visitorManagerlogin}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    addVisitors: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.addVisitors}`, params, {
                headers: {
                    'Content-Type': 'application/form-data',
                    "Authorization": `Bearer ${localStorage.getItem("visitor_manager_auth_token")}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    allVisitors: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.allVisitors}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    // "Authorization": `Bearer ${accessToken}`
                    "Authorization": `Bearer ${localStorage.getItem("visitor_manager_auth_token")}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    visitorManagerLoginLocations: function (params) {
        return new Promise((resolve, reject) => {
            API.get(`${ApiURL.visitorManagerLoginLocations}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    visitorTimeOut:function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.visitorTimeOut}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${localStorage.getItem("visitor_manager_auth_token")}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    generateOTP:function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.generateVisitorOTP}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${localStorage.getItem("visitor_manager_auth_token")}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    verifyOTP:function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.verifyVisitorOTP}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${localStorage.getItem("visitor_manager_auth_token")}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },


}

export default VisitorManagementService;
